import React, { useCallback, useEffect, useState } from "react";
import { Table } from "reactstrap";
import { ObtenerInformacionHistorialModPHE } from "./FunctionsHistorialModPHE";
import { showAlert } from "components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import { HistorialModificacionPHE } from "../Asignacion Presupuesto/TypesPresupuestoGPEHE";
import { Pagination, PaginationItem, PaginationLink, Col, Input, Row, Label } from "reactstrap";
import { ObtenerFechaFromIsoFormat } from "functions/DatesFunctions";
import ModalVistaPreviaDocumentos from "components/Varios/Modals/ModalVistaPreviaDocumentos";
import { ReactComponent as IconPdf } from "../../../../assets/icons/HorasExtras/PDF.svg"
import Cargando from "components/Varios/Cargando";
import { GetDocumentVistaPrevia } from "helpers/files";
import { authenticationService } from "services/authentication.service";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { GetNumberFormatHE } from "components/Admin/Horas Extras/Proyeccion Horas Extras/TablaUnidadesProyeccionHE";

type propsHistorialModificacionPHE = {
    idEstructura?: number | null,
    anio?: number | null
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string,
}

export default function TablaHistorialModificacion(props: propsHistorialModificacionPHE) {

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: "",
    }

    const fechaHoy: Date = new Date();

    const { idEstructura, anio } = props;

    const [historialUnidad, sethistorialUnidad] = useState<HistorialModificacionPHE[]>([]);
    const [loadingPage, setloadingPage] = useState<boolean>(false);

    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    async function ObtenerHistorialModPHE(anio: number) {
        setloadingPage(true);
        const InfoHistorica = await ObtenerInformacionHistorialModPHE(anio);
        if (InfoHistorica.status === 200 && InfoHistorica.dataResponse) {
            sethistorialUnidad(InfoHistorica.dataResponse);
        }
        else {
            showAlert(InfoHistorica.errorMessage ?? "Error al obtener la informacion", false);
        }
        setloadingPage(false);
    }
    useEffect(() => {
        ObtenerHistorialModPHE(fechaHoy.getFullYear());
    }, []);

    useEffect(() => {
        if (anio) {
            ObtenerHistorialModPHE(anio);
        }
    }, [anio]);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    const filterdesHistorial = idEstructura ? historialUnidad.filter(h => h.idunidad == idEstructura) : historialUnidad;

    let currentRows: HistorialModificacionPHE[] = filterdesHistorial.slice(indexOfFirstRow, indexOfLastRow);

    //obtiene el numero de paginas segun la cantidad de datos
    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(historialUnidad.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
    };

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const usuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, usuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP]
    )


    return (
        <>
            {loadingPage &&
                <Cargando />
            }

            {!loadingPage &&
                <div>
                    <Col md="3">
                        <div className="d-flex align-items-center justify-content-start">
                            <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                            <select
                                id="rowsPerPageSelect"
                                value={rowsPerPage}
                                onChange={handleRowsPerPageChange}
                                className="custom-select custom-select-sm mr-2"
                                style={{ width: 'auto' }}
                            >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                            </select>
                            <Label className="mb-0">filas</Label>
                        </div>
                    </Col>
                    <div className="table-responsive">
                        <Table className="table_planificacion_he table-bordered">
                            <thead className="cabeceras_tabla_servidores_act_he">
                                <tr>
                                    <th colSpan={1} align={"center"}> # </th>
                                    <th colSpan={1} align={"center"}> Fecha de Modificación</th>
                                    <th colSpan={1} align={"left"} > Unidad</th>
                                    <th colSpan={1} align={"center"} > {"Valor Solicitado (+/-)"} </th>
                                    <th colSpan={1} align={"center"} > {"Valor Modificado (+/-)"} </th>
                                    <th colSpan={1} align={"center"} > Fecha de Solicitud </th>
                                    <th colSpan={1} align={"center"} > Usuario Solicitante </th>
                                    <th colSpan={1} align={"center"} > Número Documento </th>
                                    <th colSpan={1} align={"center"} > PDF Solicitud Mod. </th>
                                </tr>
                            </thead>
                            <tbody className="tbodyAprobacionNominaTH">
                                {currentRows.map((cr, i) => {
                                    const globalIndex = indexOfFirstRow + i + 1
                                    const valorModFormateado = cr.valormod !== null ? GetNumberFormatHE(cr.valormod) : "";
                                    const valorSolFormateado = cr.valorsol !== null ? GetNumberFormatHE(cr.valorsol) : "";
                                    return (
                                        <React.Fragment key={i}>
                                            <tr className=''>
                                                <td className="centrado"> {globalIndex} </td>
                                                <td className="centrado"> {ObtenerFechaFromIsoFormat(cr.fechamod)} </td>
                                                <td className="izquierda"> {cr.unidad} </td>
                                                <td className="centrado"> {valorSolFormateado} </td>
                                                <td className="centrado"> {valorModFormateado} </td>
                                                <td className="centrado"> {ObtenerFechaFromIsoFormat(cr.fechasol)} </td>
                                                <td className="centrado"> {cr.nombrescompletos} </td>
                                                <td className="centrado"> {cr.numerodoc} </td>
                                                {cr.solicitudmodificacion && (
                                                    <td className="centrado">
                                                        <IconPdf
                                                            className={"icono-svg"}
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="PDF Solicitud Modificación"
                                                            onClick={() => onClickVerDoc(cr.solicitudmodificacion)}
                                                        />
                                                    </td>
                                                )}
                                                {!cr.solicitudmodificacion && (
                                                    <td className="centrado"> - </td>
                                                )}
                                            </tr>
                                        </React.Fragment>
                                    )
                                })}
                            </tbody>
                        </Table>
                        <Pagination size="sm" className="pagination_planificacion_he">
                            {renderPageNumbers}
                        </Pagination>
                    </div>

                    <ModalVistaPreviaDocumentos
                        cargandoDatos={stateModalVP.loading}
                        onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                        show={stateModalVP.loading || stateModalVP.url !== ""}
                        size="xl"
                        tituloModal='Documento solicitud de modificacion del presupuesto unidad'
                        urlArchivo={stateModalVP.url}
                        botonCerrar={true}
                    />
                </div>
            }
        </>
    )
}